import { UserRole } from "@/enums/user-role.enum";

const RoleHierarchy: Record<UserRole, UserRole[]> = {
    [UserRole.SuperAdmin]: [UserRole.Distributor, UserRole.Client],
    [UserRole.Distributor]: [UserRole.Client],
    [UserRole.Client]: [],
};

/**
 * Sprawdza, czy użytkownik ma dostęp do zasobu z wymaganą rolą
 * @param userRole Rola użytkownika
 * @param requiredRole Wymagana rola dostępu
 */
export function hasAccess(userRole: UserRole, requiredRole: UserRole): boolean {
    if (userRole === requiredRole) return true;
    console.log(RoleHierarchy);
    return RoleHierarchy[userRole]?.includes(requiredRole) || false;
}